import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Env from "../../Env";
import Request from "../../requests/Request";

const CsEditor = props => {
  const {
    preDraftContent,
    pageType, draftContent, saving,
    handleEditorChange, handleEditorReady,
    uploadToken, mentionPool,
  } = props;

  const mentionItemRenderer = item => {
    const ul = document.createElement('ul'),
      liDesc = document.createElement('li'),
      liValue = document.createElement('li');
    liDesc.classList.add('mention-item-desc');
    liDesc.textContent = item.desc;
    liValue.classList.add('mention-item-value');
    liValue.textContent = item.id;
    ul.appendChild(liDesc).appendChild(liValue);
    return ul;
  }

  return (
    <CKEditor
      config={{
        toolbar: [
          // Remove mediaEmbed because Shopify does not allow it
          'heading', '|',
          'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
          'indent', 'outdent', '|',
          'imageUpload', 'blockQuote', 'insertTable', 'undo', 'redo'
        ],
        extraPlugins: [mentionConverter],
        // removePlugins: ['Mention'],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h2', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h3', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h4', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h5', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h6', title: 'Heading 5', class: 'ck-heading_heading5' },
          ]
        },
        link: {
          addTargetToExternalLinks: true,
        },
        mention: {
          feeds: [
            {
              marker: '{',
              feed: mentionPool,
              itemRenderer: mentionItemRenderer,
            }
          ]
        },
        simpleUpload: {
          uploadUrl: Request.API_UPLOAD_IMAGES_EDITORS,
          headers: {
            csStore: Env.getStoreName(),
            csToken: uploadToken,
          }
        },
        // Easy upload, powerful paid solution
        // Maybe need alignment
      }}
      disabled={saving}
      editor={ClassicEditor}
      data={draftContent}
      onReady={handleEditorReady}
      onChange={(event, editor) => {
        handleEditorChange(preDraftContent + pageType, editor);
      }}
    />
  )
};

/**
 * const does not work, use raw function
 * Conversion flow: Saved HTML string --> Upcast --> Editor content / model --> Downcast to HTML (viewable by user)
 * @param editor
 */
function mentionConverter(editor) {
  // The upcast converter will convert view <span> class="mention condition_block" data-mention=""> elements to the model 'mention' text attribute.
  // Usage: Convert saved HTML string to mention model, understand by the editor
  editor.conversion.for('upcast').elementToAttribute({
    converterPriority: 'high',
    view: {
      name: 'span',
      key: 'data-mention',
      class: 'mention_condition_block',
    },
    model: {
      key: 'mention',
      value: viewItem => {
        // console.log('Element ---> Attr', viewItem);
        // The mention feature expects that the mention attribute value
        // in the model is a plain object with a set of additional attributes.
        // In order to create a proper object use the toMentionAttribute() helper method:
        return editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          // Add any other properties that you need.
          type: 'condition_block',  // Normal condition does not have this attribute
        });
      }
    },
  });

  // Downcast the model 'mention' text attribute to a view <span> element.
  // Usage: when insert mention model to editor, transform it to proper HTML string
  editor.conversion.for('downcast').attributeToElement({
    converterPriority: 'high',
    model: 'mention',
    view: (modelAttributeValue, { writer }) => {
      // console.log('Attr ---> Model', modelAttributeValue);
      // Do not convert empty attributes (lack of value means no mention).
      // Also ignore normal condition, which does not have property 'type'
      if (!modelAttributeValue || !modelAttributeValue.type) {
        return;
      }

      switch (modelAttributeValue.type) {
        case 'condition_block':
          // For block condition, transform it to <span> with additional class 'condition_block'
          return writer.createAttributeElement('span', {
            class: 'mention_condition_block',
            'data-mention': modelAttributeValue.id,
          }, {
            // Make mention attribute to be wrapped by other attribute elements.
            priority: 20,
            // Prevent merging mentions together.
            id: modelAttributeValue.uid
          });
        default:
          return;
      }
    }
  });
}

export default CsEditor;
